import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateHsaSettings = {
  name: "updateHsaSettings" as const,
  input: z.object({
    teamId: zExt.objectId(),
    enabled: z.boolean(),
    reorderHsaPaymentMethodToTop: z.boolean(),
    sendGalePaymentInfoSubmittedEvents: z.boolean(),
    checkoutButtonsSkipShopPay: z.boolean(),
  }),
  output: z.object({ success: z.boolean() }),
};
